import { useLocation } from '@reach/router'

export const useLanguage = () => {
  const location = useLocation()
  const language = location.pathname.startsWith('/en/') ? 'en' : 'de'

  return language
}
